export default __webpack_public_path__ + "3a46c78a4a4f153ec2cfc71e484d2a50.png";